module.exports = __webpack_public_path__ + "img/skip-start-btn.b6b035b9.svg";